import React from 'react'
import { Grid, Button, Message } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { toastr } from 'react-redux-toastr';
import { source } from 'react-aim';
let propName = '';
let propValue = '';
let optionsArray = [];
let managerId = null;
@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})
class Role extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            option: 'raci',
            isDisabled: true
        }
        this.createRaciObject = this.createRaciObject.bind(this);
        this.changeManagerA = this.changeManagerA.bind(this);
        this.deleteC = this.deleteC.bind(this);
        this.deleteI = this.deleteI.bind(this);
        this.deleteR = this.deleteR.bind(this);
        this.changeManager = this.changeManager.bind(this);
    }

    createOptionsArray() {
        optionsArray = [];
        if (this.props.selectedDataById.communities) {
            this.props.selectedDataById.communities.map((community) => {
                if (community.communities) {
                    community.communities.map((subCommunity) => {

                        if (!this.props.newActivityObj.raci ||
                            (propName === 'a' && this.props.newActivityObj.raci && ((this.props.newActivityObj.raci.a && this.props.newActivityObj.raci.a.communityId && this.props.newActivityObj.raci.a.communityId !== subCommunity._id) || !this.props.newActivityObj.raci.a)) ||
                            ((propName === 'r' && (!this.props.newActivityObj.raci.r || this.props.newActivityObj.raci.r.findIndex(x => x.communityId == subCommunity._id) === -1)) ||
                                (propName === 'c' && (!this.props.newActivityObj.raci.c || this.props.newActivityObj.raci.c.findIndex(x => x.communityId == subCommunity._id) === -1)) ||
                                (propName === 'i' && (!this.props.newActivityObj.raci.i || this.props.newActivityObj.raci.i.findIndex(x => x.communityId == subCommunity._id) === -1)) ||
                                (propName === 'r+a' && this.props.newActivityObj.raci && ((this.props.newActivityObj.raci.a && this.props.newActivityObj.raci.a.communityId && this.props.newActivityObj.raci.a.communityId !== subCommunity._id) || !this.props.newActivityObj.raci.a) && (!this.props.newActivityObj.raci.r || this.props.newActivityObj.raci.r.findIndex(x => x.communityId == subCommunity._id) === -1)))
                        ) {
                            optionsArray.push({ id: subCommunity._id, label: community.name + " > " + subCommunity.name, associatedTeamId: subCommunity.associatedTeam });
                            if (optionsArray.length == 0) {
                                propValue = {};
                                this.setState({ 'isDisabled': true })
                            }
                        } else {
                            if (optionsArray.length == 0) {
                                propValue = {};
                                this.setState({ 'isDisabled': true })
                            }
                        }

                    }, this)
                }

            }, this);
        }
    }

    createRaciObject(data) {
        this.setState({ 'isDisabled': true })
        switch (data.target.name) {
            case 'raci': propName = data.target.value ? data.target.value : '';
                this.setState({ option: data.target.value });

                this.setState({ 'isDisabled': true, community: 'Select', user: 'raci' })

                this.createOptionsArray();
                break;
            case 'assignment': propValue = data.target.value ? data.target.value : '';
        }
        if (data.target.name == 'assignment') {

            if (data.target.value == 'Select') {

                propValue = {};
                this.setState({ 'isDisabled': true, community: 'Select', user: 'raci' })
            }
            else {
                let value = JSON.parse(data.target.value);
                propValue = { 'communityId': value.id, 'teamId': value.associatedTeamId };
                this.setState({ 'isDisabled': true, selectedCommunity: value.id, community: data.target.value, user: 'raci' })
            }
        }


    }
    resetDropDown() {
        this.setState({ option: 'raci' })
    }
    addRaciToActivity(formData, resetForm) {
        this.setState({ isDisabled: false });


        if ((propName === 'r' || propName === 'a' || propName === 'c' || propName === 'i' || propName === 'r+a') && (propValue && propValue !== 'Select')) {
            if (!propValue.accountUserId) {
                propValue.accountUserId = this.props.RaciUserList.data[0]._id
            }
            if (!this.props.newActivityObj.raci) {
                this.props.newActivityObj.raci = {};
            }
            if (propName === 'a') {
                if (this.props.newActivityObj.raci.a && this.props.newActivityObj.raci.a.communityId) {
                    this.props.newActivityObj.raci.a.communityId = propValue.communityId;
                    this.props.newActivityObj.raci.a.accountUserId = propValue.accountUserId;
                    this.props.newActivityObj.raci.a.teamId = propValue.teamId;
                }
                else {
                    this.props.newActivityObj.raci.a = {};
                    this.props.newActivityObj.raci.a.communityId = propValue.communityId;
                    this.props.newActivityObj.raci.a.accountUserId = propValue.accountUserId;
                    this.props.newActivityObj.raci.a.teamId = propValue.teamId;
                }
            } else if (propName === 'r+a') {
                if (this.props.newActivityObj.raci.a && this.props.newActivityObj.raci.a.communityId) {
                    this.props.newActivityObj.raci.a.communityId = propValue.communityId;
                    this.props.newActivityObj.raci.a.accountUserId = propValue.accountUserId;
                    this.props.newActivityObj.raci.a.teamId = propValue.teamId;
                }
                else {
                    this.props.newActivityObj.raci.a = {};
                    this.props.newActivityObj.raci.a.communityId = propValue.communityId;
                    this.props.newActivityObj.raci.a.accountUserId = propValue.accountUserId;
                    this.props.newActivityObj.raci.a.teamId = propValue.teamId;
                }
                if (!this.props.newActivityObj.raci.r) {
                    this.props.newActivityObj.raci.r = [];
                }
                this.props.newActivityObj.raci.r.push(propValue);
            }
            else {
                if (!this.props.newActivityObj.raci[propName]) {
                    this.props.newActivityObj.raci[propName] = [];
                }
                this.props.newActivityObj.raci[propName].push(propValue);

            }
            let actionObject = {};
            actionObject[propName] = propValue;
            propValue = {}
            optionsArray = [];
            this.setState({ 'isDisabled': true, selectedCommunity: '' })
            this.props.updateNewActivityObject(Object.assign({}, this.props.newActivityObj))
        }

        else {
            toastr.error('Message', 'Please select options from dropdown.');
        }
        this.resetDropDown();

    }
    getMapping(id) {

        if (this.props.selectedDataById.communities)
            for (let i = 0; i < this.props.selectedDataById.communities.length; i++) {
                let community = this.props.selectedDataById.communities[i];
                if (id === community._id) {
                    return community.name;
                }
                if (community.communities)
                    for (let j = 0; j < community.communities.length; j++) {
                        let subCommunity = community.communities[j];
                        if (id === subCommunity._id) {
                            return community.name + " > " + subCommunity.name;
                        }
                    }
            }
    }

    changeManager(data) {
        this.setState({ isDisabled: true });
        if (data.target.value !== 'raci' && (propValue && propValue !== 'Select' && propValue.communityId)) {
            managerId = data.target.value
            propValue.accountUserId = data.target.value;
            this.setState({ isDisabled: false, user: data.target.value })
        }
        else {
            this.setState({ user: data.target.value })
        }
    }
    changeManagerA(data) {
        this.props.newActivityObj.raci.a.accountUserId = data.target.value;
        this.props.newActivityObj.raci.a.changedMapping = true;
        this.props.updateNewActivityObject(Object.assign({}, this.props.newActivityObj))
    }

    deleteC(cObj) {

        let index = this.props.newActivityObj.raci.c.filter((c) => {
            return c.communityId == cObj.communityId
        })

        let Cindex = this.props.newActivityObj.raci.c.indexOf(index[0]);
        let message = <div className="confirmMessage">
            <h3>Delete Role</h3>
            <p>Are you sure that you wish to remove this Role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index) {
                    this.props.newActivityObj.raci.c.splice(Cindex, 1);
                    this.props.updateNewActivityObject(Object.assign({}, this.props.newActivityObj))
                }
            }
        });
    }
    deleteI(iObj) {
        let index = this.props.newActivityObj.raci.i.filter((i) => {
            return i.communityId == iObj.communityId
        })
        let Iindex = this.props.newActivityObj.raci.i.indexOf(index[0]);
        let message = <div className="confirmMessage">
            <h3>Delete Role</h3>
            <p>Are you sure that you wish to remove this Role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index) {
                    this.props.newActivityObj.raci.i.splice(Iindex, 1);
                    this.props.updateNewActivityObject(Object.assign({}, this.props.newActivityObj))
                }
            }
        });
    }
    deleteR(rObj) {
        if (this.props.newActivityObj.raci.r.length > 1) {
            let index = this.props.newActivityObj.raci.r.filter((r) => {
                return r.communityId == rObj.communityId
            })
            let Rindex = this.props.newActivityObj.raci.r.indexOf(index[0]);
            let message = <div className="confirmMessage">
                <h3>Delete Role</h3>
                <p>Are you sure that you wish to remove this Role?</p>
                <span >This action is not reversible</span>
            </div>
            toastr.confirm(message, {
                onOk: () => {
                    if (index) {
                        this.props.newActivityObj.raci.r.splice(Rindex, 1);
                        this.props.updateNewActivityObject(Object.assign({}, this.props.newActivityObj))
                    }
                }
            });
        }
        else {
            toastr.error('Message', 'There should be atleast one R.');
        }
    }

    render() {
        const showA = () => {

            if (this.props.newActivityObj.raci && this.props.newActivityObj.raci.a) {
                return (
                    <Grid.Row className="formcyForm pad_0 mar_t_5 " style={{ 'padding': '0px', background: "#F2F7FB", borderBottom: "1px solid #e5e5e5" }}>
                        <Grid.Column width={3}>
                            <div className="divBlock bg-clr-lightBlue">Accountable</div>
                        </Grid.Column>
                        <Grid.Column width={7}>
                            <div className="divBlock bg-clr-lightBlue">
                                {this.getMapping(this.props.newActivityObj.raci.a.communityId)}
                            </div>
                        </Grid.Column>
                        <Grid.Column width={5}>
                            <Form.Field
                                className="defaultSelect"
                                placeholder="Select User"
                                name='user'
                                id='user'
                                required
                                value={this.props.newActivityObj.raci.a.accountUserId}
                                onChange={this.changeManagerA}
                                control='select'
                                className='users-list'
                            >
                                {
                                    this.props.communitiesMembersMap && this.props.communitiesMembersMap.get(this.props.newActivityObj.raci.a.communityId) && this.props.communitiesMembersMap.get(this.props.newActivityObj.raci.a.communityId).map(member => {
                                        return <option value={member.accountUserId} key={member.accountUserId}>{member.firstName} {member.lastName}</option>
                                    })
                                }
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>
                )
            }
        }

        const showForm = () => {
            return (
                <Form noValidate
                    name='raciForm'
                    className="formcyForm pad_0 "
                    id='raciForm'
                    ref={ref => this.form = ref}
                >
                    <Grid.Row width={16}>
                        <h4><strong> User Assignments </strong></h4>
                        <Form.Group inline >
                            <Grid.Column width={3} >
                                <Form.Field
                                    placeholder="RACI"
                                    name='raci'
                                    id='raci'
                                    required
                                    onChange={this.createRaciObject}
                                    control='select'
                                    style={{ 'width': '100%' }}
                                    value={this.state.option}
                                >
                                    <option value='raci'>RACI</option>
                                    <option value='r+a'>Responsible + Accountable</option>
                                    <option value='r'>Responsible</option>
                                    <option value='a'>Accountable</option>
                                    <option value='c'>Consulted</option>
                                    <option value='i'>Informed</option>
                                </Form.Field>
                            </Grid.Column>
                            <Grid.Column width={7}>
                                <Form.Field
                                    control='select'
                                    onChange={this.createRaciObject}
                                    name='assignment'
                                    id='assignment'
                                    value={this.state.community}
                                >
                                    <option value='Select'>Select</option>
                                    {optionsArray && optionsArray.map((community) => {
                                        return <option value={JSON.stringify(community)} key={community.id}>{community.label}</option>
                                    })}
                                </Form.Field>
                            </Grid.Column>
                            <Grid.Column width={5}>
                                <Form.Field
                                    placeholder="Select User"
                                    name='user'
                                    id='user'
                                    required
                                    onChange={this.changeManager}
                                    control='select'
                                    style={{ width: "100%" }}
                                    value={this.state.user}
                                >
                                    <option value='raci'>Select User</option>
                                    {
                                        this.props.communitiesMembersMap.get(this.state.selectedCommunity) && this.props.communitiesMembersMap.get(this.state.selectedCommunity).map(member => {
                                            return <option value={member.accountUserId} key={member.accountUserId}>{member.firstName} {member.lastName}</option>
                                        })
                                    }

                                </Form.Field>
                            </Grid.Column>
                            <Grid.Column width={1}>
                                <Button icon="plus" id="submit" onClick={(formData) => { this.addRaciToActivity(formData) }} disabled={this.state.isDisabled}></Button>
                            </Grid.Column>
                        </Form.Group>
                    </Grid.Row>
                </Form>
            )
        }

        let deleteButton = (deleteAction, id) => {
            return (
                <Grid.Column width={1}>
                    <Button type='button' icon="trash alternate" className="trash-color bg-clr-lightBlue" style={{ 'background': 'white' }} onClick={() => deleteAction(id)}></Button>
                </Grid.Column>
            )
        }
        return (

            <Grid className="practiceFlowResourcePane" >
                {showForm()}

                {showA()}
                {this.props.newActivityObj.raci && this.props.newActivityObj.raci.r &&
                    this.props.newActivityObj.raci.r.map((r) => {
                        return (
                            <Grid.Row id={r.communityId} key={r.communityId} style={{ 'padding': '0px', background: "#F2F7FB", borderBottom: "1px solid #e5e5e5" }}>
                                <Grid.Column width={3}>
                                    <div className="divBlock bg-clr-lightBlue">Responsible</div>
                                </Grid.Column>
                                <Grid.Column width={7}>
                                    <div className="divBlock bg-clr-lightBlue">
                                        {this.getMapping(r.communityId)}
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <Form.Field
                                        placeholder="Select User"
                                        name='user'
                                        id='user'
                                        required
                                        value={r.accountUserId}
                                        onChange={(data) => { r.accountUserId = data.target.value; r.changedMapping = true; this.props.updateNewActivityObject(Object.assign({}, this.props.newActivityObj)) }}
                                        control='select'
                                        className='users-list'
                                    >
                                        {
                                            this.props.communitiesMembersMap && this.props.communitiesMembersMap.get(r.communityId) && this.props.communitiesMembersMap.get(r.communityId).map(member => {
                                                return <option value={member.accountUserId} key={member.accountUserId}>{member.firstName} {member.lastName}</option>
                                            })
                                        }
                                    </Form.Field>
                                </Grid.Column>
                                {this.props.newActivityObj.raci.r.length > 1 ?
                                    deleteButton(this.deleteR, r) : ''}
                            </Grid.Row>
                        )

                    })
                }
                {this.props.newActivityObj.raci && this.props.newActivityObj.raci.c &&
                    this.props.newActivityObj.raci.c.map((c) => {
                        return (
                            <Grid.Row key={c.communityId} style={{ 'padding': '0px', background: "#F2F7FB", borderBottom: "1px solid #e5e5e5" }}>
                                <Grid.Column width={3}>
                                    <div className="divBlock bg-clr-lightBlue">Consulted</div>
                                </Grid.Column>
                                <Grid.Column width={7}>
                                    <div className="divBlock bg-clr-lightBlue">
                                        {this.getMapping(c.communityId)}
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={5}>


                                    <Form.Field
                                        placeholder="Select User"
                                        name='user'
                                        id='user'
                                        required
                                        value={c.accountUserId}
                                        onChange={(data) => { c.accountUserId = data.target.value; c.changedMapping = true; this.props.updateNewActivityObject(Object.assign({}, this.props.newActivityObj)) }}
                                        control='select'
                                        className='users-list'
                                    >
                                        {
                                            this.props.communitiesMembersMap && this.props.communitiesMembersMap.get(c.communityId) && this.props.communitiesMembersMap.get(c.communityId).map(member => {
                                                return <option value={member.accountUserId} key={member.accountUserId}>{member.firstName} {member.lastName}</option>
                                            })
                                        }
                                    </Form.Field>
                                </Grid.Column>
                                {deleteButton(this.deleteC, c)}
                            </Grid.Row>
                        )
                    })
                }
                {this.props.newActivityObj.raci && this.props.newActivityObj.raci.i &&
                    this.props.newActivityObj.raci.i.map((i) => {
                        return (
                            <Grid.Row key={i.communityId} style={{ 'padding': '0px', background: "#F2F7FB", borderBottom: "1px solid #e5e5e5" }}>
                                <Grid.Column width={3}>
                                    <div className="divBlock bg-clr-lightBlue">Informed</div>
                                </Grid.Column>
                                <Grid.Column width={7}>
                                    <div className="divBlock bg-clr-lightBlue">
                                        {this.getMapping(i.communityId)}
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <Form.Field
                                        placeholder="Select User"
                                        name='user'
                                        id='user'
                                        required
                                        value={i.accountUserId}
                                        onChange={(data) => { i.accountUserId = data.target.value; i.changedMapping = true; this.props.updateNewActivityObject(Object.assign({}, this.props.newActivityObj)) }}
                                        control='select'
                                        className='users-list'
                                    >
                                        {
                                            this.props.communitiesMembersMap && this.props.communitiesMembersMap.get(i.communityId) && this.props.communitiesMembersMap.get(i.communityId).map(member => {
                                                return <option value={member.accountUserId} key={member.accountUserId}>{member.firstName} {member.lastName}</option>
                                            })
                                        }
                                    </Form.Field>
                                </Grid.Column>
                                {deleteButton(this.deleteI, i)}
                            </Grid.Row>
                        )

                    })
                }
            </Grid>
        )
    }
}

export default Role